import './css/global.css';
import { createLinkHtmlElement } from './util';

export function loadDefaultMockTheme() {
  require('./css/default-mock-theme.css');
}

function loadCssTheme() {
  if ((window as any).__STORYBOOK_ADDONS) {
    loadDefaultMockTheme();
    return;
  }
  // Import CSS Variables for the theme
  // based on the current environment.
  // This is needed, as we can't read the API
  // URL from the environment variables
  // inside CSS, so we need to create a separate
  // file for the production and the dev API.
  if (process.env.NODE_ENV === 'development') {
    require('./css/theme-dev.css');
  } else {
    require('./css/theme-prod.css');
  }
}

export function initIonTheme() {
  require('./css/ion-theme.css');
}

export async function loadKioskCss() {
  return require('./css/kiosk-app.css');
}

loadCssTheme();

export function loadThemeByHotelId(hotelId: string) {
  if (process.env.NODE_ENV === 'development') {
    const themeLink = createLinkHtmlElement(
      `http://localhost:1337/hotels/theme?hotelId=${hotelId}`
    );
    document.head.appendChild(themeLink);
  } else {
    const themeLink = createLinkHtmlElement(
      `https://api.concierge-hotel.com/hotels/theme?hotelId=${hotelId}`
    );
    document.head.appendChild(themeLink);
  }
}

type StyleLoaderCssModule = {
  locals: {
    [className: string]: string;
  };
};
type MiniCssExtractLoaderCssModule = {
  [className: string]: string;
};

function isStyleLoaderCssModule(
  styles: StyleLoaderCssModule | MiniCssExtractLoaderCssModule
): styles is StyleLoaderCssModule {
  return (styles as StyleLoaderCssModule).locals !== undefined;
}

/**
 * Use this function for libraries that inline CSS
 * with the style-loader and make use of CSS modules.
 * Style loader css modules are not exported as default
 */
export function cssModuleClassNames(styles: StyleLoaderCssModule | MiniCssExtractLoaderCssModule) {
  return {
    getCssModuleClassName: (className: string) => {
      if (isStyleLoaderCssModule(styles)) {
        return styles.locals[className];
      }

      return styles[className];
    },
  };
}
